export default __webpack_public_path__ + "static/media/(18).c6ad4e6b.jpeg";